<template>
    <div class="af-app af-reset-email">
        <ResetEmail />
    </div>
</template>

<script>
    import ResetEmail from '@/apps/reset-email/001/components/ResetEmail';

    export default {
        name: 'App',

        components: {
            ResetEmail,
        },
    };
</script>
